__turbopack_context__.v({
  "card_wrapper": "styles-module-scss-module__bAoY5G__card_wrapper",
  "container": "styles-module-scss-module__bAoY5G__container",
  "header": "styles-module-scss-module__bAoY5G__header",
  "left_align": "styles-module-scss-module__bAoY5G__left_align",
});
